<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-70 md-xsmall-size-100 md-small-size-100 md-medium-size-90 mx-auto">
      <nav-tabs-card>
        <template slot="content">
          <!-- <span class="md-nav-tabs-title">Tasks:</span> -->
          <md-tabs class="md-success" md-alignment="left">

            <md-tab id="tab-home" :md-label="$lang.titles.details" md-icon="code" :md-disabled="deviceOffline">
              <md-table>
                <md-table-row>
                  <md-table-cell>{{$lang.general.mac_address}}</md-table-cell>
                  <md-table-cell>{{infoData.MAC}}</md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>{{$lang.general.firmware_version}}</md-table-cell>
                  <md-table-cell>{{infoData.FW}}</md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>{{$lang.general.uptime}}</md-table-cell>
                  <md-table-cell>{{infoData.uptime}}</md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell>WiFi RSSI</md-table-cell>
                  <md-table-cell>{{infoData.WIFI_RSSI}} dBm</md-table-cell>
                </md-table-row>
              </md-table>
            </md-tab>

            <md-tab id="tab-pages" md-label="WiFi" md-icon="wifi" :md-disabled="!selectedDevice.owner || deviceOffline">
              <WiFi :wifi="wifiData"></WiFi>
            </md-tab>

            <md-tab id="tab-posts" md-label="LoRa" md-icon="cloud" :md-disabled="!selectedDevice.owner || deviceOffline || !infoData.LORA_PLG">
              <LoRa :loraData="loraData" :systemData="systemData"></LoRa>
            </md-tab>
          </md-tabs>
        </template>
      </nav-tabs-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import WiFi from "./WiFi";
import LoRa from "./Lora/Main";

import axios from "axios";
import snackBar from "@/components/SnackBar";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";

import { NavTabsCard } from "@/components";

export default {
  components: {
    "snack-bar": snackBar,
    NavTabsCard,
    WiFi,
    LoRa
  },
  data() {
    return {
      interval: null,
      deviceOffline: true,
      infoData: {
        WIFI_RSSI: 0,
        uptime: "0 s"
      },
      wifiData: {
        SSID: "",
        security: "1",
        password: "",
        DHCP: "1",
        IP: "192.168.1.2",
        MASK: "255.255.255.0",
        GW: "192.168.1.1",
        DNS: "8.8.8.8"
      },
      loraData: {},
      systemData: {}
    };
  },
  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    }
  },

  beforeCreate() {
    this.$store.commit("setLoading", true);
  },

  mounted() {
    this.loadData();

    this.interval = setInterval( () => {
      this.loadData(true);
    }, 15000);
  },

  methods: {

    loadData(refresh = false){
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/devices/config",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac)
        },
        withCredentials: true
      })
        .then(response => {

          if (!refresh){
            this.wifiData = Object.assign(this.wifiData, response.data.data.WIFI);
            this.loraData = response.data.data.LORA;
            this.systemData = response.data.data.system;

            this.infoData.MAC = this.selectedDevice.mac;
            this.infoData.FW = response.data.data.system.FW;
          }

          this.infoData.WIFI_RSSI = response.data.data.WIFI.RSSI;
          this.infoData.LORA_PLG = response.data.data.LORA.plugged;

          let systemUptime = response.data.data.system.uptime;

          const days = Math.floor(systemUptime / 86400);
          systemUptime %= 86400;
          const hours = Math.floor(systemUptime / 3600);
          systemUptime %= 3600;
          const minutes = Math.floor(systemUptime / 60);
          const seconds = Math.floor(systemUptime % 60);

          this.infoData.uptime = seconds + "s";

          if (minutes > 0 || hours > 0 || days > 0) {
            this.infoData.uptime =
              minutes +
              "m " +
              this.$lang.general.and +
              " " +
              this.infoData.uptime;
          }

          if (hours > 0 || days > 0) {
            this.infoData.uptime = hours + "h, " + this.infoData.uptime;
          }

          if (days > 0) {
            this.infoData.uptime = days + "d, " + this.infoData.uptime;
          }

          this.deviceOffline = false;
          this.$store.commit("setLoading", false);

        })
        .catch(error => {
          this.$store.commit("setLoading", false);
          if (error.response.data.code == 604) {
            this.deviceOffline = true;
            this.$refs.snackbar.notify(this.$lang.messages.device_not_responding_or_offline);
          } else {
            this.$refs.snackbar.notify(this.$lang.messages.api_communication_error);
          }
        });
    }
  },

  beforeDestroy(){
    clearInterval(this.interval);
  }
};
</script>

<style scoped>
.md-table .md-table-cell {
  text-align: center;
}
</style>
